import { actionCreator } from 'utils';
import * as ShippingTypeTypes from '../types/shippingTypeTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    offset: 0,
    limit: 50,
    isSubmitting: false,

    edit: {
        loading: false,
        data: null,
        error: false,
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case ShippingTypeTypes.LOAD_SHIPPING_TYPE:
        return Object.assign({}, state, {
            ...state,
            loading: true,
        });
    case actionCreator(ShippingTypeTypes.LOAD_SHIPPING_TYPE, 'err'):
        return Object.assign({}, state, {
            ...state,
            loading: false,
            error: true,
        });
    case actionCreator(ShippingTypeTypes.LOAD_SHIPPING_TYPE, 'res'):
        return Object.assign({}, state, {
            ...state,
            loading: false,
            listing: action.data,
        });

    case ShippingTypeTypes.SET_SHIPPING_TYPE_PAGINATION:
        return Object.assign({}, state, {
            ...state,
            [action.key]: action.pagination,
        });

    case ShippingTypeTypes.EDIT_SHIPPING_TYPE:
        return Object.assign({}, state, {
            ...state,
            isSubmitting: true,
        });
    case actionCreator(ShippingTypeTypes.EDIT_SHIPPING_TYPE, 'err'):
        return Object.assign({}, state, {
            ...state,
            isSubmitting: false,
        });
    case actionCreator(ShippingTypeTypes.EDIT_SHIPPING_TYPE, 'res'):
        return Object.assign({}, state, {
            ...state,
            isSubmitting: false,
        });

    case ShippingTypeTypes.ADD_SHIPPING_TYPE:
        return Object.assign({}, state, {
            ...state,
            isSubmitting: true,
        });
    case actionCreator(ShippingTypeTypes.ADD_SHIPPING_TYPE, 'err'):
        return Object.assign({}, state, {
            ...state,
            isSubmitting: false,
        });
    case actionCreator(ShippingTypeTypes.ADD_SHIPPING_TYPE, 'res'):
        return Object.assign({}, state, {
            ...state,
            isSubmitting: false,
        });

    case ShippingTypeTypes.LOAD_EDITABLE_SHIPPING_TYPE:
        return Object.assign({}, state, {
            ...state,
            edit: {
                ...state.edit,
                loading: true,
            },
        });
    case actionCreator(ShippingTypeTypes.LOAD_EDITABLE_SHIPPING_TYPE, 'err'):
        return Object.assign({}, state, {
            ...state,
            edit: {
                ...state.edit,
                loading: false,
                error: true,
            },
        });
    case actionCreator(ShippingTypeTypes.LOAD_EDITABLE_SHIPPING_TYPE, 'res'):
        return Object.assign({}, state, {
            ...state,
            edit: {
                data: action.data,
                loading: false,
                error: false,
            },
        });

    case ShippingTypeTypes.SET_EDITABLE_SHIPPING_TYPE_DATA:
        return Object.assign({}, state, {
            ...state,
            edit: {
                ...state.edit,
                data: action.data,
            },
        });

    default:
        return state;
    }
}
